import React from 'react';

import { Text } from '@thefarmersfront/kitchen';

import styles from './InputLabel.module.scss';

type TypeInputLabel = { name: string; htmlFor: string; children: React.ReactNode };

const InputLabel = ({ name, htmlFor, children }: TypeInputLabel) => {
  return (
    <label className={styles['input-label-container']} htmlFor={htmlFor}>
      <Text size="large" color="secondary">
        {name}
      </Text>
      {children}
    </label>
  );
};

export default InputLabel;
